// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-img[data-v-302c0039] {\n  width: 150px;\n}", ""]);
// Exports
module.exports = exports;
